module.exports = __webpack_public_path__ + "static/media/paisaje-color.ad12e93e.svg";